import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import {PROFILE_STATUS_PENDINGQUALIFICATION, PROFILE_STATUS_REJECTED} from '../../../../constants'
import WithAjax from '../../../common/helpers/WithAjax'
import WithNotify from '../../../common/helpers/WithNotify'
import {clearSkillVendorCurrentProfile} from '../../../../actions/pages/skillvendor-page'
import Select from '../../../common/form/Select'
import Alert from '../../../../ui-elements/alerts/Alert'
import '../../../../css/ui-elements/modals.css'

class QualifyPopup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      className: 'modal-primary',
      size: 'default',
      skills: null,
      errorMsg: null,
      remoteRecordingCapability: null
    }

    this.toggle = this.toggle.bind(this)
    this.save = this.save.bind(this)
    this.changeSkillLevel = this.changeSkillLevel.bind(this)
    this.changeRemoteLevel = this.changeRemoteLevel.bind(this)
  }

  componentDidUpdate(prevProps) {
     if (this.state.skills === null){
      this.setState({
        skills: this.props.skills,
        remoteRecordingCapability: this.props.remoteRecordingCapability
      });
     }
  }

  toggle(e, className, size) {
    this.setState({
      modal: !this.state.modal,
      className: className,
      size: size,
      errorMsg: null
    })
  }

  save() {
    let url = 'skillVendors/' + this.props.skillVendorId + '/profiles/' + this.props.profileType + '/qualify';

    let dataToSend = {"Skills": []};
    let remoteCapability = this.state.remoteRecordingCapability;
    for (let i = 0; i < this.state.skills.length; i++) {
      let skill = this.state.skills[i];
      if (skill.SkillLevel) {
        dataToSend.Skills.push({
          SkillType: skill.SkillType,
          SkillLevel: skill.SkillLevel
        })
      }
    }

    if(this.props.profileType !== 'Translator' && this.props.profileType !== 'Adaptor'){
      dataToSend.RemoteRecordingCapability = remoteCapability;
    }

    this.props.ajax.put(
      url,
      JSON.stringify(dataToSend),
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      },
      (response) => {
        if (response && response.Errors && response.Errors.length > 0){
          let errorMsg = '';
          response.Errors.forEach((error) => {
            if (error.Messages[0]) {
              errorMsg = errorMsg + error.Messages[0] + ', ';
            }
          });

          this.setState({
            errorMsg: errorMsg
          });
        }
        else{
          this.toggle();
          this.props.clearSkillVendorCurrentProfile();

          let message = this.props.status === PROFILE_STATUS_PENDINGQUALIFICATION || this.props.status === PROFILE_STATUS_REJECTED
            ? 'The profile was qualified.'
            : 'Specialities were saved.';
          this.props.notify(message);
        }
      })
  }

  changeSkillLevel(newLevel, field){
    this.setState(prevState => {
      const newItems = [...prevState.skills];
      newItems[field.index].SkillLevel = newLevel;
      return {skills: newItems};
    })
  }

  changeRemoteLevel(newLevel, field){
    this.setState(prevState => {
      return {remoteRecordingCapability: newLevel};
    })
  }

  getSkillRow(skill, index) {
    let field = {
      name: 'SkillLevel' + index,
      value: skill.SkillLevel,
      errors: [],
      rules: {
        title: skill.SkillName
      },
      placeholder: '',
      options: [
        {
          value: '',
          label: 'Unqualified'
        },
        'Beginner',
        'Basic',
        'Experienced',
        'Advanced',
        'Professional'
      ],
      index: index
    }

    return (
      <div key={index}>
          <Select field={field} validate={this.changeSkillLevel} />
      </div>
    )
  }

  getRemoteCapability(capability) {
    let fieldCapability = {
      name: 'RemoteRecordingCapability',
      value: capability,
      errors: [],
      rules: {
        title: 'Remote Recording'
      },
      placeholder: '',
      options: [
        'Unknown',
        {
          value: 'NotCapable',
          label: 'Not capable'
        },
        'Capable',
      ]
    }

    return (
      <div>
          <Select field={fieldCapability} validate={this.changeRemoteLevel} />
      </div>
    )
  }



  render() {
    let skills = null;
    if (this.state.skills !== null) {
      skills = this.state.skills.map((skill, index) => {
        return this.getSkillRow(skill, index)
      })
    }

    let capability = null;
    if (this.state.remoteRecordingCapability !== undefined) {
      capability = this.getRemoteCapability(this.state.remoteRecordingCapability);
      }



    let openBtnLabel = this.props.status === PROFILE_STATUS_PENDINGQUALIFICATION || this.props.status === PROFILE_STATUS_REJECTED
      ? 'Qualify'
      : 'Manage skills';

    return (
      <div style={{display: 'inline-block'}}>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          wrapClassName={this.state.className}
          size={this.state.size}>
          <ModalHeader toggle={this.toggle}>Specialities</ModalHeader>
          <ModalBody>
            {this.state.errorMsg &&
              <Alert className="alert alert-danger alert-outline">
                {this.state.errorMsg}
              </Alert>
            }
            <form>
              {skills}
              {capability}
            </form>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-primary btn-rounded" onClick={() => this.save()}>
              Save
            </button>
            <button className="btn btn-default btn-rounded" onClick={this.toggle}>
              Close
            </button>
          </ModalFooter>
        </Modal>

        <button
          className="btn btn-primary btn-rounded mx-2"
          type="button"
          onClick={(e, className, size) => this.toggle(e, `modal-primary`, 'default')}>
          {openBtnLabel}
        </button>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorId: state.skillVendorPage.overview.Id,
  skills: state.skillVendorPage.currentProfile.Skills,
  profileType: state.skillVendorPage.currentProfile.ProfileType,
  status: state.skillVendorPage.currentProfile.Status,
  remoteRecordingCapability: state.skillVendorPage.currentProfile.RemoteRecordingCapability

})
const mapDispatchToProps = dispatch => ({
  clearSkillVendorCurrentProfile() { dispatch(clearSkillVendorCurrentProfile()) }
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(QualifyPopup)
